import { IMAGE_DEFAULT } from '@/main/services/constants';
import { isEmpty } from '@/main/services/utils';
import React from 'react';
import * as S from './styles';

export interface IKOGImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {}

function KOGImage({ src, ...props }: IKOGImageProps) {
  const [hasError, setHasError] = React.useState<boolean>(false);

  React.useEffect(() => {
    setHasError(false);
  }, [src]);

  const finalSrc = hasError || isEmpty(src) ? IMAGE_DEFAULT : src;

  return (
    <S.Image
      id="id-general-imagSrc"
      {...props}
      src={finalSrc}
      onError={() => setHasError(true)}
    />
  );
}

export default KOGImage;
